var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('navbar',{attrs:{"text":((_vm.$t('Configuration.name')) + " > " + (_vm.$t('Configuration.Observations_Title')))}}),_vm._v(" "),_c('ObservationsFormsDatabase',{attrs:{"observations-templates":_vm.observationsTemplates}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }